import { Button, IconButton, Stack, Typography } from '@mui/material';

import ChevronRightIcon from '@/components/Icons/ChevronRightIcon';
import DotIcon from '@/components/Icons/DotIcon';
import ExternalLinkIcon from '@/components/Icons/ExternalLinkIcon';
import { links } from '@/localization';
import { useLatestChangelog } from '@/sections/GlobalHeader/Right/LoggedIn/HelpMenu/hooks';
import { dateDisplayShort } from '@/utils/date';
import moment from 'moment';

import { ChangelogLink } from '../../styled';
import { ListItem, Section } from '../styled';

function Changelog() {
  const { latestChangelog, seenChangelog, markChangelogAsSeen } = useLatestChangelog();

  return (
    <Section sx={{ border: 'none', gap: 3 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
        <Stack gap={1}>
          <Typography variant="h3">Changelog</Typography>
          <Typography variant="body1" color="text.muted">
            What’s new at Baseten
          </Typography>
        </Stack>

        <Button
          endIcon={<ExternalLinkIcon />}
          variant="outlined"
          href={links.basetenChangeLog}
          target="_blank"
        >
          Full changelog
        </Button>
      </Stack>
      <Stack mx={-2} gap={0.5}>
        {latestChangelog.map((changelog) => (
          <ChangelogLink
            key={changelog.id}
            href={`${links.basetenChangeLog}/${changelog.slug}`}
            onClick={() => markChangelogAsSeen(undefined, changelog.id)}
            target="_blank"
            underline="none"
          >
            <ListItem>
              <Stack direction="row" alignItems="center" gap={1.5} px={1}>
                <DotIcon color={seenChangelog[changelog.id] ? 'secondary' : 'success'} />
                <Typography variant="h5" color="text.default">
                  {changelog.title}
                </Typography>
              </Stack>
              <Stack direction="row" alignItems="center" gap={2}>
                <Typography variant="body2" color="text.muted">
                  {dateDisplayShort(moment(changelog.created))}
                </Typography>
                <IconButton data-cy="list-item-arrow">
                  <ChevronRightIcon color="secondary" />
                </IconButton>
              </Stack>
            </ListItem>
          </ChangelogLink>
        ))}
      </Stack>
    </Section>
  );
}

export default Changelog;
